import { WarningLevel, ErrorDetail, CTAErrorDetail } from '../models/error-detail';
import { ApiResponse } from '../models/api-response';
import { ModalMessage, ModalStates } from '../models/modal';

// flatten API response messages. sort by critical, warning, informational
export function FlattenResponseMessages(
  messages: ErrorDetail[] | CTAErrorDetail[],
  suppressWarningLevel?: boolean
): ModalMessage {
  let errors = '';
  let warnings = '';
  let info = '';
  let isHtml = false;

  if (messages && messages.length > 0) {
    messages.forEach((e: ErrorDetail | CTAErrorDetail) => {
      if (!e) {
        return;
      }

      let m = '';

      if ('CallToAction' in e && e.CallToAction?.length) {
        m = `<strong>${e.CallToAction}: </strong>`;
        isHtml = true;
      } else if (!suppressWarningLevel) {
        m = `${WarningLevel[e.WarningLevel]}: `;
      }

      m = `${m}${e.FieldName || ''} ${e.Message}\n\n`;

      if (e.WarningLevel == WarningLevel.Critical) {
        errors += m;
      } else if (e.WarningLevel == WarningLevel.Warning) {
        warnings += m;
      } else if (e.WarningLevel == WarningLevel.Informational) {
        info += m;
      }
    });
  }

  return new ModalMessage(errors + warnings + info, isHtml);
}

// flatten API response messages by the desired warning level type(s)
export function FlattenResponseMessagesByTypes(
  warningLevels: WarningLevel[],
  messages: ErrorDetail[]
) {
  let responseMessages = [];

  if (messages && messages.length > 0 && warningLevels && warningLevels.length > 0) {
    // loop through all the warning levels and attach the associated error messages
    warningLevels.forEach(warningLevel => {
      let warningMessages = messages.filter(msg => msg.WarningLevel == warningLevel);

      warningMessages.forEach(msg => {
        responseMessages.push({
          WarningLevel: WarningLevel[msg.WarningLevel],
          Message: msg.Message
        });
      });
    });
  }

  return responseMessages;
}

// get the styling we need for the modal
// if there are any critical errors - critical styling
// else if there are any warnings - warning styling
// else - success styling
export function GetResponseModalStyle(messages: ErrorDetail[]): ModalStates {
  let errors = false;
  let warnings = false;

  if (messages && messages.length > 0) {
    messages.forEach(e => {
      if (!e) {
        return;
      }

      if (e.WarningLevel == WarningLevel.Critical) {
        errors = true;
      } else if (e.WarningLevel == WarningLevel.Warning) {
        warnings = true;
      }
    });
  }

  if (errors) {
    return ModalStates.Error;
  } else if (warnings) {
    return ModalStates.Warning;
  } else {
    return ModalStates.Success;
  }
}
